var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5.0 -10.0 110.0 135.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m84.375 34.375c-0.8125 0-1.5938-0.3125-2.2188-0.90625l-15.625-15.625c-1.2188-1.2188-1.2188-3.1875 0-4.4062s3.1875-1.2188 4.4062 0l15.625 15.625c1.9688 1.9688 0.53125 5.3438-2.2188 5.3438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 43.75c-0.8125 0-1.5938-0.3125-2.2188-0.90625l-15.625-15.625c-1.2188-1.2188-1.2188-3.1875 0-4.4062s3.1875-1.2188 4.4062 0l15.625 15.625c1.9688 1.9688 0.53125 5.3438-2.2188 5.3438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.812 0c-3.7812 0-7.3438 1.4688-10.031 4.1562l-68.625 68.625c-0.78125 0.78125-0.375-0.09375-7.0312 23.219-0.5625 2 0.9375 3.9688 3 3.9688 0.6875 0-0.75 0.34375 22.719-6.375 0.1875-0.0625 1.1875-0.65625 1.3438-0.78125 0 0 0.5-0.75 0.59375-0.875 0.125-0.25 0.28125-0.875 0.28125-1.1562 0.125-1.9062 0-1.5-14.281-15.812l66.438-66.406c4.9375-4.9375 13.531-1.4688 13.531 5.5938 0 2.125-0.8125 4.0938-2.3125 5.5938l-59.281 59.281c-1.2188 1.2188-1.2188 3.1875 0 4.4062s3.1875 1.2188 4.4062 0l59.281-59.25c8.9062-8.9062 2.5312-24.188-10.031-24.188zm-74.906 80.969 8.125 8.125-11.375 3.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.360cd935.svg";
export { ForwardRef as ReactComponent };